export default __webpack_public_path__ + "static/media/illustration-algowork-w@2x.59a6be23.png";